<template>
  <div class="container">
    <el-tabs v-model="currentTab">
      <el-tab-pane :label="$t('BC.BCInfo')" name="1">
        <div class="searchBox_top">
          <!--保存-->
          <el-button type="primary" v-if="canSave" @click="saveDetail" v-acl="SaveBc">{{ $t('BC.saveDraft') }}</el-button>
          <!--提交-->
          <el-button type="primary" v-if="canSave" @click="submitDetail" v-acl="SubmitBc">{{ $t('BC.submit')
          }}</el-button>
          <!--审批-->
          <el-button type="primary" v-show="canAppr && status == 'appr_in' && emplFlag != 'SUP'" @click="approvalFun"
            v-acl="CompleteBc">{{ $t('BC.audit') }}</el-button>
          <el-button type="primary" @click="historyBack">{{ $t('BC.close') }}</el-button>
          <el-button type="primary" v-if="canSave" @click="onComplete" v-acl="DirectBc">Complete</el-button>
        </div>
        <el-form :model="DetailForm" ref="DetailForm" :rules="DetailRules" label-width="160px">
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('BC.createBy')" prop="creator">
                <!--创建人-->
                <el-input v-model.trim="DetailForm.creator" clearable disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('BC.createDate')" prop="createDate">
                <!--创建日期-->
                <el-date-picker value-format="yyyy-MM-dd" v-model="DetailForm.createDate" type="date"
                  disabled></el-date-picker>
                <!-- <el-input v-model.trim="DetailForm.createDate" clearable disabled></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('BC.BCNumber')" prop="serialNo">
                <!--BC编号-->
                <el-input v-model.trim="DetailForm.serialNo" clearable disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('BC.status')" prop="status">
                <!--状态-->
                <ic-select clearable table="TT_BC" field="STATUS" v-model="DetailForm.status" disabled
                  :placeholder="$t('BC.sel')"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item :label="$t('BC.SSRNumber')" prop="ssrNo">
                <!--SSR编号-->
                <el-input v-model.trim="DetailForm.ssrNo" clearable :disabled="!canSave"
                  @blur="querySsrByNo($event, 'SSR')" @clear="clearSsrByNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('BC.RFPNumber')" prop="rfpNo">
                <!--RFP编号-->
                <el-input v-model.trim="DetailForm.rfpNo" clearable :disabled="!canSave"
                  @blur="querySsrByNo($event, 'RFP')" @clear="clearSsrByNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('BC.Category1')" prop="oneLevelCategoryIds"
                v-if="DetailForm.ssrNo || DetailForm.rfpNo || status == 'appr_pass' || status == 'appr_in'">
                <el-select v-model="DetailForm.oneLevelCategoryIds" @visible-change="changeCategory1"
                  @remove-tag='removeCategory1' multiple disabled :placeholder="$t('BC.sel')">
                  <el-option :key="index" v-for="(item, index) in categoryList1" :label="item.name"
                    :value="item.tmCategoryId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('BC.Category1')" prop="oneLevelCategoryIds" v-else>
                <el-select v-model="DetailForm.oneLevelCategoryIds" @visible-change="changeCategory1"
                  @remove-tag='removeCategory1' multiple :placeholder="$t('BC.sel')">
                  <el-option :key="item.categoryLevel1Id" v-for="item in categoryList1" :label="item.categoryLevel1Name"
                    :value="item.categoryLevel1Id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('BC.Category2')" prop="twoLevelCategoryIds"
                v-if="DetailForm.ssrNo || DetailForm.rfpNo || status == 'appr_pass' || status == 'appr_in'">
                <el-select v-model="DetailForm.twoLevelCategoryIds" multiple disabled :placeholder="$t('BC.sel')">
                  <el-option :key="index" v-for="(item, index) in categoryList2" :label="item.name"
                    :value="item.tmCategoryId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('BC.Category2')" prop="twoLevelCategoryIds" v-else>
                <el-select v-model="DetailForm.twoLevelCategoryIds" multiple :placeholder="$t('BC.sel')">
                  <el-option :key="index" v-for="(item, index) in categoryList2" :label="item.categoryLevel2Name"
                    :value="item.categoryLevel2Id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('BC.supplier')" prop="supplierName">
                <!-- 供应商 -->
                <el-input class="handle-input" v-model="DetailForm.supplierName" clearable :disabled="!canSave"
                  @clear="clearSupplierId" @click.native="showSelSupplierDialogFun(canSave)">
                  <el-divider slot="suffix" direction="vertical"></el-divider>
                  <i class="el-icon-search el-input_icon pointerCss" slot="suffix" :disabled="!canSave"></i>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('BC.projectName')" prop="projectName">
                <el-input v-model="DetailForm.projectName" clearable :disabled="!canSave"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" v-if='emplFlag != "SUP"'>
              <!--除了供应商以外的-->
              <el-form-item :label="$t('BC.isApproval')" prop="needCfoApprover">
                <!--是否提交CFO审批-->
                <el-select v-model="DetailForm.needCfoApprover" :placeholder="$t('BC.sel')" disabled>
                  <el-option :label="$t('BC.yes')" value="true"></el-option>
                  <el-option :label="$t('BC.no')" value="false"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if='emplFlag == "SUP"'>
              <el-form-item :label="$t('BC.SubmitBy')" prop="approverId">
                <!--提交审批人-->
                <el-select v-model="DetailForm.approverId" clearable :disabled="!canSave" :placeholder="$t('BC.sel')">
                  <el-option :key="index" v-for="(item, index) in SubmitBySSList" :label="item.userName"
                    :value="item.tmUserId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('BC.cqsApprover')" prop="cqsApproverId">
                <!--提交审批人cqs-->
                <el-select v-model="DetailForm.cqsApproverId" clearable :disabled="!canSave" :placeholder="$t('BC.sel')">
                  <el-option :key="index" v-for="(item, index) in SubmitByCQSList" :label="item.name"
                    :value="item.tmUserId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-card class="box-card" v-show="status == 'draft' || status == 'appr_back'">
          <div slot="header" class="clearfix">
            <span>{{ $t('BC.businessTemplate') }}</span>
          </div>
          <el-table :data="TemplateList" border highlight-current-row class="table">
            <el-table-column show-overflow-tooltip prop="documentName">
              <!--模版-->
              <template slot-scope="scope">
                <el-link type="primary" @click.native="downloadTemplate(scope.row.path, scope.row.name)">{{ scope.row.name
                }}
                </el-link>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>{{ $t('BC.businessPDF') }}</span>
          </div>
          <el-table :data="PDFlist" border highlight-current-row class="table">
            <el-table-column show-overflow-tooltip prop="documentName">
              <!--文件-->
              <template slot-scope="scope">
                <el-link type="primary" @click.native="downloadFile(scope.row)">{{ scope.row.documentName }} </el-link>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="tmDocumentId" v-if="canSave">
              <template slot-scope="scope">
                <el-link type="primary"
                  @click.native.prevent="deleteFile(scope.row.tmDocumentId, scope.$index, PDFlist)">{{ $t('common.del')
                  }}</el-link>
                <!--删除-->
              </template>
            </el-table-column>
          </el-table>
          <!-- <el-upload :show-file-list="false" ref="upload" :headers="header" :action="fileUploadUrl" :on-success="uploadSuccess" multiple accept=".PDF">
                        <el-button type="primary">{{$t("common.upload")}}</el-button>
                    </el-upload> -->
          <el-upload v-if="uploadStatus && canSave" ref="upload" action="upload" :http-request="uploadConfirm"
            :before-upload="beforePDFUpload" :show-file-list="true" :file-list="fileList" multiple accept=".PDF"
            :limit="1" name="file">
            <el-button slot="trigger" size="small" type="primary">{{ $t('BC.selectFile') }}</el-button>
          </el-upload>
        </el-card>
      </el-tab-pane>
      <el-tab-pane :label="$t('BC.approvalLog')" name="2">
        <el-table :data="auditLog" border highlight-current-row class="table">
          <el-table-column show-overflow-tooltip prop="createDate" :label="$t('BC.OperationTime')">
            <template slot-scope="scope">{{ scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm:ss") }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="operatorName" :label="$t('BC.OperatorName')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="action" :label="$t('BC.PedagogicalOperation')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="comments" :label="$t('BC.opinion')"></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="showSelSupplierDialog" append-to-body width="70%">
      <SelSupplier ref="supplierSelRef" :multipleSelectionFlag="true" v-if="SupplierNameDialogReset"
        @subCallMethod="selectSupplierMethod"></SelSupplier>
      <!-- <SelSupplier ref="supplierSelRef" :multipleSelectionFlag="true" :tmSupplierId='DetailForm.tmSupplierId' v-if="SupplierNameDialogReset" @subCallMethod="selectSupplierMethod"></SelSupplier> -->
    </el-dialog>
    <el-dialog :title="CQSCategoryLeader ? $t('BC.reviewOperationWindow') : $t('BC.approvalWindow')"
      :visible.sync="approvalVisible" width="34%">
      <el-form :model="approvaForm" ref="approvaForm" :rules="approvaRules" inline label-width="160px">
        <el-form-item :label="CQSCategoryLeader ? $t('BC.reviewer') : $t('BC.auditor')" prop="auditor">
          <el-input v-model="approvaForm.auditor" disabled></el-input>
        </el-form-item>
        <el-form-item :label="CQSCategoryLeader ? $t('BC.reviewTime') : $t('BC.approvalTime')" prop="approvalTime">
          <el-input v-model="approvaForm.approvalTime" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('BC.Category1')" prop="oneLevelCategoryIds" v-if="needAutoSave">
          <el-select v-model="DetailForm.oneLevelCategoryIds" @visible-change="changeCategory1"
            @remove-tag='removeCategory1' multiple disabled :placeholder="$t('BC.sel')">
            <el-option :key="index" v-for="(item, index) in categoryList1" :label="item.name"
              :value="item.tmCategoryId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('BC.Category2')" prop="twoLevelCategoryIds" v-if="needAutoSave">
          <el-select v-model="DetailForm.twoLevelCategoryIds" multiple disabled :placeholder="$t('BC.sel')">
            <el-option :key="index" v-for="(item, index) in categoryList2" :label="item.name"
              :value="item.tmCategoryId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('BC.isApproval')" prop="needCfoApprover" v-if="needAutoSave">
          <!--是否提交CFO审批-->
          <el-select v-model="DetailForm.needCfoApprover" :placeholder="$t('BC.sel')" disabled>
            <el-option :label="$t('BC.yes')" value="true"></el-option>
            <el-option :label="$t('BC.no')" value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('BC.cqsApprover')" prop="cqsApproverId" v-if="needAutoSave">
          <!--提交审批人cqs-->
          <el-select v-model="DetailForm.cqsApproverId" clearable :disabled="!canSave" :placeholder="$t('BC.sel')">
            <el-option :key="index" v-for="(item, index) in SubmitByCQSList" :label="item.userName"
              :value="item.tmUserId"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="CQSCategoryLeader ? $t('BC.RevisionComments') : $t('BC.approvalResults')"
          prop="approvalResults">
          <el-radio-group v-model="approvaForm.approvalResults" @change="ResultsChange">
            <el-radio label="PASS">{{ $t('BC.pass') }}</el-radio>
            <el-radio label="REJECT">{{ CQSCategoryLeader ? $t('BC.have') : $t('BC.noPass') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('BC.RevisionComments')" prop="approvalRemarks"
          :rules="approvaForm.approvalResults == 'REJECT' ? approvaForm.approvalRemarks : []">
          <el-input v-model="approvaForm.approvalRemarks" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="300" style="width:200px"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="approvalVisible = false" type="primary">{{ $t('BC.cancel') }}</el-button>
        <el-button type="primary" @click="approvalConfirm()">{{ $t('BC.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import supplierApi from "@/api/supplier/supplier";
import { fileService } from "@/api/common/file-utils";
import BCApi from "@/api/BC/BC";
import commonConstatns from "@/constants/commonConstants";
import commonFun from "@/utils/commonFun";
import { apiService } from "@/api/material/material-master-data";
import SelSupplier from '@/components/page/base-data/factory-sel-page';
export default {
  components: { IcSelect, SelSupplier },
  data() {
    return {
      uploadStatus: true,
      categoryList1: [],
      categoryList2: [],
      PDFlist: [],
      ttBcId: false,
      showSelSupplierDialog: false,
      DetailForm: {
        creator: localStorage.getItem("ms_userCd"),
        createDate: this.$options.filters["dateFormatFilter"](new Date()),
        tmSupplierIds: [],
        needCfoApprover: '',
        oneLevelCategoryIds: [],
        twoLevelCategoryIds: [],
        cqsApproverId: '',
        tmSupplierId: '',//ss选完供应商，之后获取Category1和Category2
        projectName: '',
        supplierName: null,
      },
      showFileList: false,
      DetailRules: {
        needCfoApprover: [{ required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }],
        approverId: [{ required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }],
        cqsApproverId: [{ required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }],
        supplierName: [{ required: true, message: this.$t("visitPlan.noEmpty"), trigger: ['change', 'blur'] }],
        projectName: [{ required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'blur' }],
        oneLevelCategoryIds: [{ required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }],
        twoLevelCategoryIds: [{ required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }],
      },
      currentTab: '1',
      TemplateList: [
        { path: '/templates/download/Business Proposal Strategic Initiatives (Template).DOCX', name: 'Business Proposal Strategic Initiatives (Template).DOCX' },
        { path: '/templates/download/Business_Proposal Supplier Facility Investment (Template).DOCX', name: 'Business_Proposal Supplier Facility Investment (Template).DOCX' },
      ],
      emplFlag: '',
      SupplierNameDialogReset: false,
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      dcId: null,
      canAppr: '',
      auditLog: [],//审批日志
      approvaForm: {
        auditor: localStorage.getItem("ms_userCd"),
        approvalTime: this.$options.filters["dateFormatFilter"](new Date()),
        approvalResults: '',
      },
      approvaRules: {
        approvalResults: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ],
        approvalRemarks: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ],
      },
      approvalVisible: false,
      documents: [],
      SubmitByCQSList: [],
      SubmitBySSList: [],
      allCategory: [],
      status: 'draft',
      tmSupplierId: '',
      needAutoSave: '',
      canSave: true,
      canSaveCfo: true,
      CQSCategoryLeader: false,
    }
  },
  created() {
    //用户所属系统
    this.emplFlag = localStorage.getItem('ms_emplFlag');
    let roles = JSON.parse(localStorage.getItem("ms_roles"));
    for (let i = 0, len = roles.length; i < len; i++) {
      if (roles[i] == 'CQS category leader') {//CQS category leader
        this.CQSCategoryLeader = true;
      }
    }
    if (this.$route.query.ttBcId) {
      this.ttBcId = this.$route.query.ttBcId;
      this.showFileList = false
      this.getDetail(this.$route.query.ttBcId)
      this.getPDFList(this.$route.query.ttBcId)
    }
    else if (this.$route.query.id) {
      this.ttBcId = this.$route.query.id;
      this.showFileList = false
      this.getDetail(this.$route.query.id)
      this.getPDFList(this.$route.query.id)
    }
    else {
      this.showFileList = true
      this.queryPrimaryKey()
      this.DetailForm.needCfoApprover = 'true'
    }
    // if(this.emplFlag=='SUP'){
    //     this.getSubmitByCQS()
    // this.getSubmitByCQS()
    // }
    this.getSubmitByCQS()
    this.getSubmitBySS()
  },
  methods: {
    //获取主键id
    queryPrimaryKey() {
      let that = this
      BCApi.queryPrimaryKey().then(res => {
        if (res.code === '200') {
          that.ttBcId = res.data;
          that.DetailForm.ttBcId = res.data
        }
      });
    },
    getDetail(id) {
      let that = this
      BCApi.getDetail(id).then(res => {
        console.log(res.data)
        that.needAutoSave = res.data.needAutoSave
        that.canSave = res.data.canSave
        that.canSaveCfo = res.data.canSaveCfo//是否可以保存cfo
        res.data.supplierName = ''
        that.DetailForm = res.data
        if (commonFun.isEmpty(res.data.cqsApproverId)) {
          that.DetailForm.cqsApproverId = ''
        }
        this.DetailForm.needCfoApprover = res.data.needCfoApprover.toString()
        that.DetailForm.tmSupplierIds = []
        // that.DetailForm.supplierName = ''
        let suppliers = res.data.suppliers
        let tmSupplierIds = []
        let name = [];
        suppliers.forEach((item, index) => {
          that.DetailForm.tmSupplierIds.push(item.tmSupplierId);
          name.push(item.supplierName);
        })
        that.DetailForm.supplierName = name.join(",");
        that.auditLog = res.data.logs
        that.canAppr = res.data.canAppr
        that.status = res.data.status
        //审批中和审批通过查所有
        if (res.data.ssrNo || res.data.rfpNo || that.status == "appr_pass" || that.status == "appr_in") {
          that.getCategory(res.data.oneLevelCategoryIds[0])
        } else {
          if (res.data.tmSupplierId) {
            that.tmSupplierId = res.data.tmSupplierId
            this.getGroupCategory(res.data.tmSupplierId)
          }
        }
      });
    },
    onComplete() {
      let that = this;
      this.$refs.DetailForm.validate(valid => {
        if (valid) {
          if (this.PDFlist.length == 0) {
            that.$message({ message: this.$t("BC.PleaseUpload"), type: "warning" });
            return;
          }
          let data = {}
          if (!that.ttBcId) {
            data = {
              serialNo: !!this.DetailForm.serialNo ? this.DetailForm.serialNo : "",
              status: !!this.DetailForm.status ? this.DetailForm.status : "",
              ssrNo: !!this.DetailForm.ssrNo ? this.DetailForm.ssrNo : "",
              rfpNo: !!this.DetailForm.rfpNo ? this.DetailForm.rfpNo : "",
              needCfoApprover: !!this.DetailForm.needCfoApprover ? this.DetailForm.needCfoApprover : "",
              approverId: !!this.DetailForm.approverId ? this.DetailForm.approverId : "",
              tmSupplierIds: !!this.DetailForm.tmSupplierIds ? this.DetailForm.tmSupplierIds : "",
              supplierName: !!that.DetailForm.supplierName ? that.DetailForm.supplierName : "",
              oneLevelCategoryIds: !!this.DetailForm.oneLevelCategoryIds ? this.DetailForm.oneLevelCategoryIds : "",
              twoLevelCategoryIds: !!this.DetailForm.twoLevelCategoryIds ? this.DetailForm.twoLevelCategoryIds : "",
              tmSupplierId: this.DetailForm.tmSupplierId,
              cqsApproverId: this.DetailForm.cqsApproverId,
              projectName: this.DetailForm.projectName,
            }
          } else {
            data = this.DetailForm
          }
          console.log(data)
          BCApi.direct(data).then(res => {
            console.log("🚀 ~ file: BCDetail.vue:425 ~ BCApi.direct ~ res:", res)
            if (res.code == '200') {
              that.$message({
                message: this.$t('已归档成功'),
                type: "success"
              });
              that.historyBack()
            }
          });
        } else {
          return false;
        }
      });
    },
    saveDetail() {
      let that = this;
      let data = {}
      if (!this.ttBcId) {//没有id新增
        data = {
          serialNo: !!this.DetailForm.serialNo ? this.DetailForm.serialNo : "",
          status: !!this.DetailForm.status ? this.DetailForm.status : "",
          ssrNo: !!this.DetailForm.ssrNo ? this.DetailForm.ssrNo : "",
          rfpNo: !!this.DetailForm.rfpNo ? this.DetailForm.rfpNo : "",
          needCfoApprover: !!this.DetailForm.needCfoApprover ? this.DetailForm.needCfoApprover : "",
          approverId: !!this.DetailForm.approverId ? this.DetailForm.approverId : "",
          tmSupplierIds: !!this.DetailForm.tmSupplierIds ? this.DetailForm.tmSupplierIds : "",
          supplierName: !!this.DetailForm.supplierName ? this.DetailForm.supplierName : "",
          oneLevelCategoryIds: !!this.DetailForm.oneLevelCategoryIds ? this.DetailForm.oneLevelCategoryIds : "",
          twoLevelCategoryIds: !!this.DetailForm.twoLevelCategoryIds ? this.DetailForm.twoLevelCategoryIds : "",
          tmSupplierId: this.DetailForm.tmSupplierId,
          cqsApproverId: this.DetailForm.cqsApproverId,
          projectName: this.DetailForm.projectName,

        }

      } else {
        data = this.DetailForm
        if (commonFun.isEmpty(that.DetailForm.ssrNo)) {
          data.ssrNo = ''
        }
      }
      console.log(data)
      BCApi.save(data).then(res => {
        if (res.code == '200') {
          that.$message({
            message: this.$t("common.saveSuccess"),
            type: "success"
          });
          if (!that.ttBcId && that.documents.length > 0) {//没有id说明新增 维护关系
            let attachment = {};
            that.ttBcId = res.data
            attachment.documents = that.documents;
            attachment.seq = '1';
            attachment.tsRecId = res.data;
            attachment.tsReckindId = 'BC_PDF';
            that.uploadStatus = false
            fileService.saveFile(attachment).then((saveRes) => {
              that.getPDFList();
              that.uploadStatus = true//刷新一下pdf上传的临时显示数组
              that.documents = []
            })
          }
          // that.ttBcId = res.data
          that.getDetail(res.data)
          that.$router.replace({
            path: `/BCDetail`,
            query: {
              ttBcId: res.data,
              timestamp: new Date().getTime()
            }
          })
        }
      });
    },
    submitDetail() {
      let that = this;
      console.log(that.DetailForm.supplierName)
      console.log(that.DetailForm.projectName)
      this.$refs.DetailForm.validate(valid => {
        if (valid) {
          if (this.PDFlist.length == 0) {
            that.$message({ message: this.$t("BC.PleaseUpload"), type: "warning" });
            return;
          }
          let data = {}
          if (!that.ttBcId) {
            data = {
              serialNo: !!this.DetailForm.serialNo ? this.DetailForm.serialNo : "",
              status: !!this.DetailForm.status ? this.DetailForm.status : "",
              ssrNo: !!this.DetailForm.ssrNo ? this.DetailForm.ssrNo : "",
              rfpNo: !!this.DetailForm.rfpNo ? this.DetailForm.rfpNo : "",
              needCfoApprover: !!this.DetailForm.needCfoApprover ? this.DetailForm.needCfoApprover : "",
              approverId: !!this.DetailForm.approverId ? this.DetailForm.approverId : "",
              tmSupplierIds: !!this.DetailForm.tmSupplierIds ? this.DetailForm.tmSupplierIds : "",
              supplierName: !!that.DetailForm.supplierName ? that.DetailForm.supplierName : "",
              oneLevelCategoryIds: !!this.DetailForm.oneLevelCategoryIds ? this.DetailForm.oneLevelCategoryIds : "",
              twoLevelCategoryIds: !!this.DetailForm.twoLevelCategoryIds ? this.DetailForm.twoLevelCategoryIds : "",
              tmSupplierId: this.DetailForm.tmSupplierId,
              cqsApproverId: this.DetailForm.cqsApproverId,
              projectName: this.DetailForm.projectName,
            }
          } else {
            data = this.DetailForm
          }
          console.log(data)
          BCApi.submit(data).then(res => {
            if (res.code == '200') {
              that.$message({
                message: this.$t("common.submitSuccess"),
                type: "success"
              });
              that.historyBack()
            }
          });
        } else {
          return false;
        }
      });
    },
    querySsrByNo(event, type) {
      let that = this
      if (event.target.value) {
        BCApi.querySsrByNo(event.target.value, type).then(res => {
          if (res.code == '200') {
            that.DetailForm.oneLevelCategoryIds = [res.data.category1Id]
            that.DetailForm.twoLevelCategoryIds = [res.data.category2Id]
            that.getCategory(res.data.category1Id)
          } else {
            that.$message({
              message: res.msg,
              type: "warning"
            });
            that.DetailForm.ssrNo = ''
            that.DetailForm.oneLevelCategoryIds = []
            that.DetailForm.twoLevelCategoryIds = []
            that.$nextTick(() => {
              that.$refs.DetailForm.clearValidate();
            })
          }
        });
      }

    },
    clearSsrByNo() {
      let that = this
      that.DetailForm.oneLevelCategoryIds = []
      that.DetailForm.twoLevelCategoryIds = []

      that.$nextTick(() => {
        that.$refs.DetailForm.clearValidate();
      })
      if (that.DetailForm.tmSupplierId) {
        that.getGroupCategory(that.DetailForm.tmSupplierId)
      }
    },
    //审批
    approvalFun() {
      this.approvalVisible = true
    },
    //审批
    approvalConfirm() {
      let that = this;
      this.$refs.approvaForm.validate(valid => {
        if (valid) {
          //needAutoSave为true 先调保存
          if (that.needAutoSave) {
            BCApi.save(this.DetailForm).then(res => {
              if (res.code == '200') {
                let data = {
                  status: that.approvaForm.approvalResults,
                  remark: that.approvaForm.approvalRemarks,
                  bizId: that.ttBcId
                }
                BCApi.approval(data).then(res => {
                  if (res.code == '200') {
                    this.historyBack()
                  }
                });
              }
            });
          } else {
            let data = {
              status: that.approvaForm.approvalResults,
              remark: that.approvaForm.approvalRemarks,
              bizId: that.ttBcId
            }
            BCApi.approval(data).then(res => {
              if (res.code == '200') {
                this.historyBack()
              }
            });
          }


        } else {
          return false;
        }
      });
      this.approvalVisible = true
    },
    uploadSuccess(response, file, fileList) {
      if (null == this.PDFlist) {
        this.PDFlist = [];
      }
      this.PDFlist.push(...(commonFun.convertToArray(response.data)));
    },
    clearSupplierId() {
      let that = this
      this.SupplierNameDialogReset = false
      this.DetailForm.tmSupplierIds = [];
      this.DetailForm.tmSupplierId = null;
      if (!(that.DetailForm.ssrNo || that.DetailForm.rfpNo)) {
        this.categoryList1 = []
        this.categoryList2 = []
        that.DetailForm.oneLevelCategoryIds = []
        that.DetailForm.twoLevelCategoryIds = []
      }
      that.DetailForm.supplierName = null
      this.$nextTick(() => {
        this.SupplierNameDialogReset = true
        this.$refs['DetailForm'].clearValidate(['oneLevelCategoryIds']);
        this.$refs['DetailForm'].clearValidate(['twoLevelCategoryIds']);
      })

    },

    selectSupplierMethod: function (supList, groupOrfacility) {
      let that = this;
      console.log(supList)
      let name = [];
      let supperSupplierId = ''
      if (supList.length > 0) {
        that.DetailForm.tmSupplierIds = []
        if (groupOrfacility) {//group
          supperSupplierId = supList[0].tmSupplierId
          this.DetailForm.tmSupplierId = supList[0].tmSupplierId
          supList.forEach(((item) => {
            that.DetailForm.tmSupplierIds.push(item.tmSupplierId);
            name.push(item.supplierName);
          }))
        } else {
          supperSupplierId = supList[0].supperSupplierId
          this.DetailForm.tmSupplierId = supList[0].supperSupplierId
          supList.forEach(((item) => {
            that.DetailForm.tmSupplierIds.push(item.tmSupplierId);
            name.push(item.plantName);
          }))
        }
        that.DetailForm.supplierName = name.join(",");
        if (!(that.DetailForm.ssrNo || that.DetailForm.rfpNo)) {
          that.getGroupCategory(supperSupplierId)
        }
      }
      that.SupplierNameDialogReset = false
      that.showSelSupplierDialog = false;
      that.$nextTick(() => {
        that.SupplierNameDialogReset = true
      })
    },
    //获取Category1 Category2
    getGroupCategory(id) {
      let that = this
      supplierApi.getGroupCategoryList(id).then((res) => {
        if (res.data.length > 0) {
          //获取的是所有的二级，去掉categoryLevel1Id重复的
          this.allCategory = res.data
          let arr = res.data
          let hash = {};
          var newArr = arr.reduce((item, next) => {
            hash[next.categoryLevel1Id] ? '' : hash[next.categoryLevel1Id] = true && item.push(next);
            return item
          }, []);
          that.categoryList1 = newArr
          if (this.ttBcId) {//说明不是新增
            this.changeCategory1()
          }
        } else {
          this.DetailForm.oneLevelCategoryIds = []
          this.DetailForm.twoLevelCategoryIds = []
          this.categoryList1 = []
          this.categoryList2 = []
          this.$nextTick(() => {
            this.$refs['DetailForm'].clearValidate(['oneLevelCategoryIds']);
            this.$refs['DetailForm'].clearValidate(['twoLevelCategoryIds']);
          })
        }
      })
    },
    getCategory(category1) {
      apiService.findCategory({ categoryLevel: 1, typeList: ['common', 'Logistic'] }).then((res) => {
        this.categoryList1 = res.data;
        apiService.findCategory({ categoryLevel: 2, pid: category1, typeList: ['common', 'Logistic'] }).then((res) => {
          this.categoryList2 = res.data;
        });
      });
    },

    removeCategory1(val) {
      let that = this
      let arr = that.categoryList2
      let twoLevelCategoryIds = that.DetailForm.twoLevelCategoryIds
      if (twoLevelCategoryIds.length > 0) {
        let delId = []//删掉的categoryLevel1下的categoryLevel2Id
        arr = arr.filter(item => {
          if (item.categoryLevel1Id == val) {
            delId.push(item.categoryLevel2Id)
          }
          return item.categoryLevel1Id != val
        })
        this.categoryList2 = arr
        let tempId = twoLevelCategoryIds.filter((x) => !delId.some((item) => x === item));
        this.DetailForm.twoLevelCategoryIds = tempId
      }

    },
    changeCategory1(val) {
      let that = this
      if (!val) {
        //获取选中的category1
        let allCategory = this.allCategory
        let pids = this.DetailForm.oneLevelCategoryIds
        let arr = []
        console.log(this.DetailForm.oneLevelCategoryIds)
        console.log(this.allCategory)
        allCategory.forEach((pitem, pindex) => {
          pids.forEach((id, index) => {
            if (pitem.categoryLevel1Id == id) {
              console.log(pitem)
              arr.push(pitem)
            }
          })
        })
        that.categoryList2 = arr
        console.log(arr)
      }
    },
    //文件列表pdf数据获取
    getPDFList: function () {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = this.ttBcId;
      attachment.tsReckindId = 'BC_PDF';
      fileService.getFileList(attachment).then((fileRes) => {
        this.PDFlist = fileRes;
      })
    },
    //PDF上传
    uploadConfirm: function (item) {
      let _this = this;
      const isPDF = item.file.type === "application/pdf";
      if (!isPDF) {
        _this.$message.error(_this.$t('visitPlan.OnlyPdf'));
        return false;
      }
      const isLt10M = item.file.size / 1024 / 1024 < 10; //文件大小限制
      if (!isLt10M) {
        this.$message.error("文件大小不能超过10M！");
        return isLt10M;
      }

      let formData = new FormData();
      formData.append("file", item.file);
      fileService.BCfileUploadPDF(formData).then((res) => {
        if (!_this.ttBcId) {
          _this.documents = res.data
          // _this.documents.push.apply(_this.documents, res.data)
        } else {//如果有id 调用后台方法进行文件关系维护
          let attachment = {};
          attachment.documents = res.data;
          attachment.seq = '1';
          attachment.tsRecId = this.ttBcId;
          attachment.tsReckindId = 'BC_PDF';
          _this.uploadStatus = false
          fileService.saveFile(attachment).then((saveRes) => {
            let attachment = {};
            attachment.seq = '1';
            attachment.tsRecId = this.ttBcId;
            attachment.tsReckindId = 'BC_PDF';
            fileService.getFileList(attachment).then((fileRes) => {
              //上传成功后 删除上次上传的
              if (fileRes.length > 1) {
                let tmDocumentId = fileRes[0].tmDocumentId
                fileService.deleteFile(tmDocumentId).then(res => {
                  _this.getPDFList()
                });
              } else {
                _this.PDFlist = fileRes;
              }
            })
            _this.uploadStatus = true
          })
        }

      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then((res) => { })
    },
    //文件删除
    deleteFile: function (tmDocumentId, index, files) {
      if (tmDocumentId) {
        fileService.deleteFile(tmDocumentId).then((res) => {
          files.splice(index, 1);
        })
      } else {//还没保存
        files.splice(index, 1);
      }

    },
    //模版下载
    downloadTemplate: function (path, name) {
      fileService.downloadTemplate(path, name)
    },
    showSelSupplierDialogFun(val) {
      if (val) {//如果没有置灰
        this.showSelSupplierDialog = true
        this.SupplierNameDialogReset = true
        // this.DetailForm.tmSupplierId = ''
        // this.DetailForm.supplierName = '';
      }

    },
    getSubmitBySS() {
      let data = {
        type: 'SS'
      }
      BCApi.getCategoryLeader(data).then(res => {
        if (res.code == '200') {
          this.SubmitBySSList = res.data
        }
      });
    },
    getSubmitByCQS() {
      let data = {
        type: 'CQS'
      }
      BCApi.getCategoryLeaderUser(data).then((res) => {
        if (res.code == '200') {
          this.SubmitByCQSList = res.data
        }
      })
      // BCApi.getCategoryLeader(data).then(res => {
      //   if (res.code == '200') {
      //     this.SubmitByCQSList = res.data
      //   }
      // });
    },
    historyBack: function () {
      this.$router.go(-1);
    },

  }

}
</script>
<style lang="scss" scoped>
.searchBox_top {
  margin-bottom: 20px;
}

.el-table {
  margin-bottom: 10px;
}

.el-select {
  width: 100%;
}

.el-date-editor {
  width: 100%;
}</style>
